import {Fragment, useState} from 'react';
import {Link} from 'react-router';

function ResetPasswordPage() {
  const [passwordshow1, setpasswordshow1] = useState(false);
  const [passwordshow2, setpasswordshow2] = useState(false);
  const [passwordshow3, setpasswordshow3] = useState(false);
  return (
    <Fragment>
      <div className="container">
        <div className="authentication authentication-basic h-full items-center text-defaultsize text-defaulttextcolor">
          <div className="grid grid-cols-12">
            <div className="sm:col-span-2 md:col-span-3 lg:col-span-4 xl:col-span-4 xxl:col-span-4"></div>
            <div className="col-span-12 sm:col-span-8 md:col-span-6 lg:col-span-4 xl:col-span-4 xxl:col-span-4">
              <div className="my-[2.5rem] flex justify-center">
                <Link to={'/'}>
                  <img src={'/images/logo/logo.png'} alt="logo" className="desktop-logo max-w-[150px]" />
                  <img src={'/images/logo/logo.png'} alt="logo" className="desktop-dark max-w-[150px]" />
                </Link>
              </div>
              <div className="box">
                <div className="box-body !p-[3rem]">
                  <p className="h5 mb-2 text-center font-semibold">Reset Password</p>
                  <p className="mb-4 text-center font-normal text-[#8c9097] opacity-[0.7] dark:text-white/50">
                    Hello Jhon !
                  </p>
                  <div className="grid grid-cols-12 gap-y-4">
                    <div className="col-span-12 xl:col-span-12">
                      <label htmlFor="reset-password" className="form-label text-default">
                        Current Password
                      </label>
                      <div className="input-group">
                        <input
                          type={passwordshow1 ? 'text' : 'password'}
                          className="form-control form-control-lg !rounded-e-none"
                          id="reset-password"
                          placeholder="current password"
                        />
                        <button
                          onClick={() => setpasswordshow1(!passwordshow1)}
                          aria-label="button"
                          className="ti-btn ti-btn-light !mb-0 !rounded-s-none"
                          type="button"
                          id="button-addon2"
                        >
                          <i className={`${passwordshow1 ? 'ri-eye-line' : 'ri-eye-off-line'} align-middle`}></i>
                        </button>
                      </div>
                    </div>
                    <div className="col-span-12 xl:col-span-12">
                      <label htmlFor="reset-newpassword" className="form-label text-default">
                        New Password
                      </label>
                      <div className="input-group">
                        <input
                          type={passwordshow2 ? 'text' : 'password'}
                          className="form-control form-control-lg !rounded-e-none"
                          id="reset-newpassword"
                          placeholder="new password"
                        />
                        <button
                          onClick={() => setpasswordshow2(!passwordshow2)}
                          aria-label="button"
                          className="ti-btn ti-btn-light !mb-0 !rounded-s-none"
                          type="button"
                          id="button-addon21"
                        >
                          <i className={`${passwordshow2 ? 'ri-eye-line' : 'ri-eye-off-line'} align-middle`}></i>
                        </button>
                      </div>
                    </div>
                    <div className="col-span-12 mb-2 xl:col-span-12">
                      <label htmlFor="reset-confirmpassword" className="form-label text-default">
                        Confirm Password
                      </label>
                      <div className="input-group">
                        <input
                          type={passwordshow3 ? 'text' : 'password'}
                          className="form-control form-control-lg !rounded-e-none"
                          id="reset-confirmpassword"
                          placeholder="confirm password"
                        />
                        <button
                          onClick={() => setpasswordshow3(!passwordshow3)}
                          aria-label="button"
                          className="ti-btn ti-btn-light !mb-0 !rounded-s-none"
                          type="button"
                          id="button-addon22"
                        >
                          <i className={`${passwordshow3 ? 'ri-eye-line' : 'ri-eye-off-line'} align-middle`}></i>
                        </button>
                      </div>
                      <div className="mt-4">
                        <div className="form-check !ps-0">
                          <input className="form-check-input" type="checkbox" value="" id="defaultCheck1" />
                          <label
                            className="form-check-label font-normal text-[#8c9097] dark:text-white/50"
                            htmlFor="defaultCheck1"
                          >
                            Remember password ?
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-span-12 mt-2 grid xl:col-span-12">
                      <Link
                        to={`${import.meta.env.BASE_URL}authentication/signin/signinbasic/`}
                        className="ti-btn ti-btn-lg bg-primary !font-medium text-white dark:border-defaultborder/10"
                      >
                        Create
                      </Link>
                    </div>
                  </div>
                  <div className="text-center">
                    <p className="mt-4 text-[0.75rem] text-[#8c9097] dark:text-white/50">
                      Already have an account?{' '}
                      <Link to={`${import.meta.env.BASE_URL}`} className="text-primary">
                        Sign In
                      </Link>
                    </p>
                  </div>
                  <div className="authentication-barrier my-4 text-center">
                    <span>OR</span>
                  </div>
                  <div className="btn-list text-center">
                    <button type="button" aria-label="button" className="ti-btn ti-btn-icon ti-btn-light me-[0.365rem]">
                      <i className="ri-facebook-line font-bold text-dark opacity-[0.7]"></i>
                    </button>
                    <button type="button" aria-label="button" className="ti-btn ti-btn-icon ti-btn-light me-[0.365rem]">
                      <i className="ri-google-line font-bold text-dark opacity-[0.7]"></i>
                    </button>
                    <button type="button" aria-label="button" className="ti-btn ti-btn-icon ti-btn-light">
                      <i className="ri-twitter-line font-bold text-dark opacity-[0.7]"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="sm:col-span-2 md:col-span-3 lg:col-span-4 xl:col-span-4 xxl:col-span-4"></div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default ResetPasswordPage;
